import { CoreIcon } from '../core-icon';
import chevronLeftCircleFillSVG from '../../assets/icons/chevron-left-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ChevronLeftCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronLeftCircleFillSVG} {...props} />;
};
